if (!customElements.get('local-fire-show-gallery')) {
  customElements.define('local-fire-show-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.onClick) return;
      this.main = this.querySelector('img.local-fire-show-gallery__mainImage');
      this.blur = this.querySelector('img.local-fire-show-gallery__blur');
      this.thumbs = Array.from(this.querySelectorAll('button[data-src]'));
      this.status = this.querySelector('.local-fire-show-gallery__status');
      this.caption = this.closest('section').querySelector('.local-fire-show-gallery__caption');
      this.index = Math.max(0, this.thumbs.findIndex((thumb) => thumb.getAttribute('aria-pressed') === 'true'));
      this.version = 0;
      this.onClick = (event) => {
        const thumb = event.target.closest('button[data-src]');
        if (thumb && this.contains(thumb)) {
          this.show(this.thumbs.indexOf(thumb));
          return;
        }
        const arrow = event.target.closest('.local-fire-show-gallery__arrow');
        if (!arrow || !this.contains(arrow) || arrow.disabled) return;
        this.show(this.index + (arrow.classList.contains('local-fire-show-gallery__arrow--prev') ? -1 : 1));
      };
      this.onKeyDown = (event) => {
        if (!this.thumbs.length || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeyDown);
    }
    show(index) {
      if (!this.main || !this.thumbs.length) return;
      this.index = (index + this.thumbs.length) % this.thumbs.length;
      const thumb = this.thumbs[this.index];
      const src = thumb.dataset.src;
      if (!src) return;
      const version = ++this.version;
      this.clearPending();
      this.thumbs.forEach((item) => {
        item.classList.toggle('is-active', item === thumb);
        item.setAttribute('aria-pressed', String(item === thumb));
      });
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.main.style.opacity = reducedMotion ? '1' : '0';
      if (this.blur) this.blur.style.opacity = reducedMotion ? '.82' : '0';
      this.swapTimer = window.setTimeout(() => {
        const reveal = () => {
          if (version !== this.version) return;
          this.main.style.opacity = '1';
          if (this.blur) this.blur.style.opacity = '.82';
        };
        this.reveal = reveal;
        this.main.addEventListener('load', reveal);
        this.main.addEventListener('error', reveal);
        for (const image of [this.main, this.blur].filter(Boolean)) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = src;
        }
        this.main.alt = thumb.dataset.alt || '';
        if (this.main.complete) reveal();
        this.revealTimer = window.setTimeout(reveal, 3000);
        if (this.caption) {
          this.caption.textContent = thumb.dataset.caption || '';
          if (thumb.dataset.link && thumb.dataset.linkLabel) {
            const link = document.createElement('a');
            link.href = thumb.dataset.link;
            link.textContent = thumb.dataset.linkLabel;
            this.caption.appendChild(document.createTextNode(' '));
            this.caption.appendChild(link);
          }
        }
        if (this.status) this.status.textContent = `Image ${this.index + 1} sur ${this.thumbs.length} — ${this.main.alt}`;
      }, reducedMotion ? 0 : 140);
    }
    clearPending() {
      window.clearTimeout(this.swapTimer);
      window.clearTimeout(this.revealTimer);
      if (this.main && this.reveal) {
        this.main.removeEventListener('load', this.reveal);
        this.main.removeEventListener('error', this.reveal);
      }
    }
    disconnectedCallback() {
      this.version++;
      this.clearPending();
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeyDown);
      this.onClick = null;
    }
  });
}
